import React, {useEffect} from 'react';

export const useAutoHeight = (frameElementName, dependencies = []) =>
  useEffect(() => {
    const handleData = (event) => {
      try {
        const data = JSON.parse(event.data);
        const iframe = document.getElementsByName(frameElementName)[0];
        if (data.contentheight && iframe.height !== data.contentheight) {
          iframe.height = data.contentheight;
        }
      } catch (err) {
        console.log('error when getting client iframe height:', err);
      }
    };
    window.addEventListener('message', handleData, false);
    return () => {
      window.removeEventListener('message', handleData, false);
    };
  }, [frameElementName, ...dependencies]);
